// components/ContactInfoSection.tsx
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaLinkedin,
} from "react-icons/fa";

export default function ContactInfoSection() {
  return (
    <section className="bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] px-6 py-20">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
        {/* 左侧文字区域 */}
        <div>
          <h2 className="text-xs md:text-sm text-[#7b5cff] uppercase mb-2 tracking-[0.2em] font-semibold">
            Get in Touch
          </h2>
          <h1 className="text-2xl md:text-3xl font-extrabold mb-4 bg-gradient-to-r from-[#6a2dd9] via-[#9a8dfc] to-[#b794ff] bg-clip-text text-transparent">
            Don&apos;t hesitate to contact us for more information.
          </h1>
          <p className="text-sm md:text-base text-[#2a0f4c]/80 mb-6 border-b border-purple-100 pb-4">
            Feel free to get in touch with us via email. <br />We&apos;re here to support your journey with
            AI NOVA Global Services.
          </p>

          {/* Social / LinkedIn */}
          {/* <div className="mb-6">
            <div className="flex flex-wrap items-center gap-4 text-sm md:text-base">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#6a2dd9] hover:text-[#4c19c9] font-medium transition-colors"
              >
                <FaLinkedin className="text-lg" />
                <span>Follow us on LinkedIn</span>
              </a>
            </div>
          </div> */}
        </div>

        {/* 右侧信息卡片 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            {
              icon: <FaMapMarkerAlt />,
              title: "Head Office",
              desc: " 8 Marina Boulevard #29-01, MBFC, Singapore 018981.",
              highlight: true,
            },
            {
              icon: <FaEnvelope />,
              title: "Email Us",
              desc: "getintouch@ainova.sg",
            },
          ].map(({ icon, title, desc, highlight }, i) => (
            <div
              key={i}
              className={`flex flex-col h-48 md:h-52 rounded-2xl p-4 md:p-5 ${
                highlight
                  ? "bg-gradient-to-br from-purple-500 via-indigo-500 to-purple-600 text-white shadow-[0_14px_40px_rgba(138,79,255,0.45)]"
                  : "bg-white/80 border border-purple-100 text-[#2a0f4c] shadow-[0_10px_30px_rgba(138,79,255,0.12)]"
              }`}
            >
              <div className="text-2xl mb-3">
                {icon}
              </div>
              <h4 className="font-semibold mb-1">{title}</h4>
              <p
                className={`whitespace-pre-line text-xs md:text-sm ${
                  highlight ? "text-white/90" : "text-[#4b2a85]/80"
                }`}
              >
                {desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
